/**
 * localStorage flags for tours that have been seen / dismissed. Keyed
 * per tour so adding a new tour doesn't re-trigger the existing ones
 * for users who already finished them. Same browser only — we don't
 * sync seen-tour state to the server because the cost of re-showing a
 * tour on a fresh device is low and a server endpoint would be
 * disproportionate.
 */

const STORAGE_PREFIX = 'mobilauncher.tour.';

export function hasSeen(tourId: string): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(STORAGE_PREFIX + tourId) === '1';
  } catch {
    return false;
  }
}

export function markSeen(tourId: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_PREFIX + tourId, '1');
  } catch {
    /* private browsing or quota — fall back to re-showing the tour, fine */
  }
}

export function resetSeen(tourId: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_PREFIX + tourId);
  } catch {
    /* ignore */
  }
}
